/**
 * Represents a validated coupon as returned by the validateCoupon GraphQL query.
 * The `discount` field is a percentage (0–100).
 */
export interface Coupon {
  id: string;
  code: string;
  discount: number;
  cycles?: number | null;
  expiry_date?: string | null;
}

/**
 * Computes the final price after applying a percentage coupon discount.
 *
 * @param basePrice - The base price (in any currency unit, e.g. BRL float or cents).
 * @param coupon    - The validated coupon, or null if none.
 * @returns         The discounted price, clamped to a minimum of 0.
 */
export function computeDiscountedPrice(basePrice: number, coupon: Coupon | null): number {
  if (!coupon) return basePrice;
  const discountAmount = (basePrice * coupon.discount) / 100;
  return Math.max(0, basePrice - discountAmount);
}
